import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useCallback } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import { CloseIcon } from "@icons";
import {
    MatchableItem,
    AccrualMatchTableCallbacks,
    AccrualMatchSection,
} from "../types";
import styles from "../EditAllocationDrawer.module.scss";

interface RemoveCellOptions {
    section: AccrualMatchSection;
}

type RemoveCellMeta = ViewTableMeta<
    AccrualMatchTableCallbacks,
    RemoveCellOptions
>;

export const RemoveCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, MatchableItem, unknown>) => {
        const meta = table.options.meta as RemoveCellMeta | undefined;
        const onRemoveRow = meta?.callbacks?.onRemoveRow;
        const isChildRow = row.depth > 0;

        const handleRemove = useCallback(() => {
            onRemoveRow?.(row.original.id);
        }, [onRemoveRow, row.original.id]);

        if (isChildRow || !onRemoveRow) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell captureClicks>
                <button
                    className={styles.removeRowButton}
                    onClick={handleRemove}
                    aria-label="Remove"
                >
                    <CloseIcon />
                </button>
            </ViewTableCell>
        );
    },
);
RemoveCell.displayName = "RemoveCell";
